import React, { lazy } from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { CONSTANTS } from '@/utils/constants.js';

const App = lazy(() => import('./App.jsx'));

if (import.meta.env.VITE_REACT_APP_SENTRY_URL) {
  Sentry.init({
    dsn: `https://${import.meta.env.VITE_REACT_APP_SENTRY_URL}/${
      import.meta.env.VITE_SENTRY_PROJECT_ID || '4'
    }`,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.httpClientIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      CONSTANTS.SERVER_URLS.serverUrl,
      CONSTANTS.SERVER_URLS.dictionaryUrl,
      CONSTANTS.SERVER_URLS.staticUrl,
    ],
    // Session Replay
    replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    enabled: process.env.NODE_ENV === 'production',
    beforeSend(event, hint) {
      const error = hint.originalException;

      // Filter Axios errors
      if (error && error.isAxiosError) {
        console.warn('Filtered Axios error:', error);
        return null; // Do not send to Sentry
      }

      // Filter Chunk Load errors
      if (error instanceof Error && error.message.includes('Loading chunk')) {
        console.warn('Filtered Chunk Load error:', error);
        return null;
      }

      return event; // Send other errors
    },
  });

  Sentry.setTag('Whitelabel', import.meta.env.VITE_REACT_APP_TITLE);
}

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
